module.exports = __webpack_public_path__ + "img/4c35a6569cba4a22b46422ad07ec2f37.db177e03.png";